import { isNavigationItemActive } from "../../navigation/navigationConfig";

function joinClasses(...values) {
  return values.filter(Boolean).join(" ");
}

export default function WorkspaceSideMenu({
  groups = [],
  location,
  activeGroupKey = "",
  onGroupSelect,
  onNavigate,
}) {
  if (!Array.isArray(groups) || groups.length === 0) {
    return null;
  }

  return (
    <aside className="hidden w-80 shrink-0 lg:block">
      <div className="sticky top-[112px] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
        <div className="border-b border-slate-100 bg-slate-50 px-4 py-4">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Navigatie
          </p>
          <p className="mt-1 text-sm text-slate-600">
            Schakel tussen hoofdgroepen en open direct de onderliggende routes.
          </p>
        </div>

        <nav className="max-h-[calc(100vh-170px)] overflow-y-auto p-3" aria-label="Zijmenu">
          <div className="space-y-3">
            {groups.map((group) => {
              const Icon = group.icon;
              const isActiveGroup = group.key === activeGroupKey;

              return (
                <section
                  key={group.key}
                  className={joinClasses(
                    "overflow-hidden rounded-xl border transition",
                    isActiveGroup
                      ? "border-slate-900 bg-slate-900 text-white"
                      : "border-slate-200 bg-white"
                  )}
                >
                  <button
                    type="button"
                    onClick={() => onGroupSelect?.(group.key)}
                    className="flex w-full items-start gap-3 px-4 py-3 text-left"
                  >
                    {Icon ? (
                      <span
                        className={joinClasses(
                          "inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl",
                          isActiveGroup
                            ? "bg-white/10 text-white"
                            : "bg-slate-100 text-slate-600"
                        )}
                      >
                        <Icon className="h-5 w-5" />
                      </span>
                    ) : null}

                    <span className="min-w-0 flex-1">
                      <span
                        className={joinClasses(
                          "block text-sm font-semibold",
                          isActiveGroup ? "text-white" : "text-slate-900"
                        )}
                      >
                        {group.label}
                      </span>
                      {group.description ? (
                        <span
                          className={joinClasses(
                            "mt-1 block text-xs leading-5",
                            isActiveGroup ? "text-slate-200" : "text-slate-500"
                          )}
                        >
                          {group.description}
                        </span>
                      ) : null}
                    </span>
                  </button>

                  <div className="space-y-1 border-t border-white/10 bg-white p-2 text-slate-900">
                    {(group.items || []).map((item) => {
                      const itemActive = isNavigationItemActive(item, location);
                      const ItemIcon = item.icon;
                      return (
                        <button
                          key={item.to}
                          type="button"
                          onClick={() => onNavigate?.(item.to)}
                          className={joinClasses(
                            "flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-sm transition",
                            itemActive
                              ? "bg-blue-50 text-blue-900"
                              : "text-slate-700 hover:bg-slate-50"
                          )}
                        >
                          {ItemIcon ? (
                            <ItemIcon
                              className={joinClasses(
                                "h-4 w-4 shrink-0",
                                itemActive ? "text-blue-700" : "text-slate-500"
                              )}
                            />
                          ) : null}
                          <span className="min-w-0 flex-1 truncate">{item.label}</span>
                          {item.badge ? (
                            <span className="shrink-0 rounded-full bg-red-100 px-2 py-0.5 text-[11px] font-semibold text-red-700">
                              {item.badge}
                            </span>
                          ) : null}
                        </button>
                      );
                    })}
                  </div>
                </section>
              );
            })}
          </div>
        </nav>
      </div>
    </aside>
  );
}
